import { Select as MantineSelect } from '@mantine/core';
import { ChevronDown } from 'lucide-react';

export const Select = MantineSelect.extend({
	defaultProps: {
		rightSection: <ChevronDown className='select-chevron' />,
		withCheckIcon: false,
		allowDeselect: false,
		clearable: true,
		size: 'md',
		rightSectionPointerEvents: 'none',
		comboboxProps: {
			position: 'bottom',
			offset: 0,
			middlewares: { flip: false, shift: false },
		},
	},
});
